import { css } from '@emotion/css'
import { borderRadius, spacing, zIndex, fontSize, fontFamily } from '../../styles'
import { shorthandHelper } from '../../styles/helpers'
import getThemeColors, { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'
import { scrollGradient } from '../../utils/styleUtils'

const counterArrow = 74

const styles = {
  wrapper: css({
    position: 'relative',
    width: 240,
    fontFamily: fontFamily.body,
  }),

  wrapperError: css({
    '&:focus-within > div:last-child': {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`,
    },
  }),

  label: css({
    height: 40,
    width: '100%',
    userSelect: 'none',
    cursor: 'pointer',
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    position: 'relative',
    color: colors.jumbo,
    backgroundColor: colors.white,
    boxSizing: 'border-box',

    '&[readonly]': {
      cursor: 'default',
      pointerEvents: 'none',
      backgroundColor: colors.athensGray,
    },

    '&:focus': {
      outline: 'none',
    },
  }),

  openLabel: css({
    zIndex: zIndex.level6,
  }),

  errorLabel: css({
    borderColor: colors.mandy,

    '&:focus': {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`,
    },
  }),

  placeholderInput: css({
    color: colors.grayChateau,
  }),

  input: css({
    boxSizing: 'border-box',
    color: colors.jumbo,
    fontSize: fontSize.default,
    lineHeight: '40px',
    padding: shorthandHelper([0, counterArrow, 0, spacing.default]),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    borderRadius: borderRadius.default,
  }),

  arrow: css({
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    padding: shorthandHelper([0, spacing.default]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  counter: css({
    marginRight: spacing.default,
  }),

  body: css({
    listStyle: 'none',
    margin: 0,
    padding: spacing.default,
    position: 'absolute',
    top: 40,
    left: 0,
    right: 0,
    maxHeight: 280,
    overflowY: 'auto',
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: zIndex.level6,
    marginTop: -1,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,

    // Scroll gradient
    ...scrollGradient,

    '&:focus': {
      outline: 'none',
    },

    '& > * + *': {
      marginTop: spacing.default,
    },
  }),
}

export default styles

export const wrapperTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    '&:focus-within > div:last-child': {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`,
    },
  })
}

export const labelTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    '&:focus': {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`,
    },
  })
}
